"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _assertThisInitialized = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var eth_1 = require("../../lib/eth");

var utils_1 = require("../../modules/wallet/utils");

var WalletProvider = /*#__PURE__*/function (_react_1$default$Pure) {
  _inherits(WalletProvider, _react_1$default$Pure);

  function WalletProvider() {
    var _this;

    _classCallCheck(this, WalletProvider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WalletProvider).apply(this, arguments));

    _this.handleChangeAccount = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props, isConnected, isConnecting, address, onChangeAccount, wallet;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, isConnected = _this$props.isConnected, isConnecting = _this$props.isConnecting, address = _this$props.address, onChangeAccount = _this$props.onChangeAccount;
                _context.prev = 1;
                _context.next = 4;
                return utils_1.buildWallet();

              case 4:
                wallet = _context.sent;

                if (isConnected && !isConnecting && wallet.address !== address) {
                  onChangeAccount(wallet);
                }

                _context.next = 10;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 8]]);
      }));
    };

    _this.handleChangeNetwork = function () {
      return __awaiter(_assertThisInitialized(_assertThisInitialized(_this)), void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this$props2, isConnected, isConnecting, chainId, onChangeNetwork, wallet;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, isConnected = _this$props2.isConnected, isConnecting = _this$props2.isConnecting, chainId = _this$props2.chainId, onChangeNetwork = _this$props2.onChangeNetwork;
                _context2.prev = 1;
                _context2.next = 4;
                return utils_1.buildWallet();

              case 4:
                wallet = _context2.sent;

                if (isConnected && !isConnecting && wallet.chainId !== chainId) {
                  onChangeNetwork(wallet);
                }

                _context2.next = 10;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 8]]);
      }));
    };

    return _this;
  }

  _createClass(WalletProvider, [{
    key: "handle",
    value: function handle(method, type, handler) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var provider;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return eth_1.getConnectedProvider();

              case 2:
                provider = _context3.sent;

                if (!provider) {
                  _context3.next = 18;
                  break;
                }

                _context3.prev = 4;
                _context3.t0 = type;
                _context3.next = _context3.t0 === 'accountsChanged' ? 8 : _context3.t0 === 'chainChanged' ? 10 : 12;
                break;

              case 8:
                provider[method](type, handler);
                return _context3.abrupt("break", 13);

              case 10:
                provider[method](type, handler);
                return _context3.abrupt("break", 13);

              case 12:
                return _context3.abrupt("break", 13);

              case 13:
                return _context3.abrupt("return");

              case 16:
                _context3.prev = 16;
                _context3.t1 = _context3["catch"](4);

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[4, 16]]);
      }));
    }
  }, {
    key: "on",
    value: function on(type, handler) {
      this.handle('on', type, handler).catch(function (error) {
        return console.error(error.message);
      });
    }
  }, {
    key: "off",
    value: function off(type, handler) {
      this.handle('removeListener', type, handler).catch(function (error) {
        return console.error(error.message);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // try to connect wallet
      var onConnect = this.props.onConnect;
      onConnect(); // add listeners

      this.on('accountsChanged', this.handleChangeAccount);
      this.on('chainChanged', this.handleChangeNetwork);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // remove listeners
      this.off('accountsChanged', this.handleChangeAccount);
      this.off('chainChanged', this.handleChangeNetwork);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return children;
    }
  }]);

  return WalletProvider;
}(react_1.default.PureComponent);

exports.default = WalletProvider;